var _rect, _rect2, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 32,
    height: 32,
    rx: 6,
    fill: "#FE815F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8124 23.9948C28.8124 27.3309 26.0673 30.0354 22.6812 30.0354H11.1V26.0083H22.6812C23.8099 26.0083 24.7249 25.1068 24.7249 23.9948C24.7249 22.8827 23.8099 21.9812 22.6812 21.9812H18.5937V17.9542H22.6812C23.8099 17.9542 24.7249 17.0527 24.7249 15.9406C24.7249 14.8286 23.8099 13.9271 22.6812 13.9271H11.1V9.9H22.6812C26.0673 9.9 28.8124 12.6045 28.8124 15.9406C28.8124 17.4877 28.222 18.899 27.2512 19.9677C28.222 21.0364 28.8124 22.4477 28.8124 23.9948Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1 13.9271H21.047C18.9341 11.4817 15.5702 9.9 11.7812 9.9C11.5525 9.9 11.3254 9.90576 11.1 9.91713V13.9271ZM23.1308 21.9812H19.275V17.9541H23.1308C23.2827 18.6047 23.3624 19.2781 23.3624 19.9677C23.3624 20.6573 23.2827 21.3306 23.1308 21.9812ZM11.1 26.0083H21.047C18.9342 28.4536 15.5702 30.0354 11.7812 30.0354C11.5526 30.0354 11.3254 30.0296 11.1 30.0182V26.0083Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1 9.9C16.7436 9.9 21.3187 14.4075 21.3187 19.9677C21.3187 25.5279 16.7436 30.0354 11.1 30.0354V26.0083C14.4862 26.0083 17.2312 23.3038 17.2312 19.9677C17.2312 16.6315 14.4862 13.9271 11.1 13.9271V9.9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.e67ae68c9b81f84e7a587134ef5ace79.svg";
export { ForwardRef as ReactComponent };